const createTransactionsApi = ({ transactions }) => {
    return {
        transactions: {
            send: transactions.send,
            broadcast: transactions.broadcast,
        },
    };
};
const transactionsApiDefinition = {
    id: 'transactionsApi',
    type: 'api',
    factory: createTransactionsApi,
    dependencies: [
        //
        'transactions',
    ],
};
export default transactionsApiDefinition;
